/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type PrintSupportedCategoriesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PrintSupportedCategoriesQuery = {
    __typename: 'Query';
    supportedCategories: Array<{
        __typename: 'CategoryAndLocale';
        categoryKey: string;
        locale: string;
        isExperimental: boolean;
    }>;
};

export const PrintSupportedCategoriesDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PrintSupportedCategories' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supportedCategories' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'categoryKey' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'isExperimental' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __usePrintSupportedCategoriesQuery__
 *
 * To run a query within a React component, call `usePrintSupportedCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintSupportedCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintSupportedCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrintSupportedCategoriesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        PrintSupportedCategoriesQuery,
        PrintSupportedCategoriesQueryVariables
    >
) {
    return Apollo.useQuery<PrintSupportedCategoriesQuery, PrintSupportedCategoriesQueryVariables>(
        PrintSupportedCategoriesDocument,
        baseOptions
    );
}
export function usePrintSupportedCategoriesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PrintSupportedCategoriesQuery,
        PrintSupportedCategoriesQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        PrintSupportedCategoriesQuery,
        PrintSupportedCategoriesQueryVariables
    >(PrintSupportedCategoriesDocument, baseOptions);
}
export type PrintSupportedCategoriesQueryHookResult = ReturnType<
    typeof usePrintSupportedCategoriesQuery
>;
export type PrintSupportedCategoriesLazyQueryHookResult = ReturnType<
    typeof usePrintSupportedCategoriesLazyQuery
>;
export type PrintSupportedCategoriesQueryResult = Apollo.QueryResult<
    PrintSupportedCategoriesQuery,
    PrintSupportedCategoriesQueryVariables
>;
